import React, {useEffect, useMemo, useRef, useState} from "react";
import {Box,Grid, IconButton} from "@mui/material";
import {DownloadRounded} from "@mui/icons-material";
import {ColDef, ICellRendererParams} from "ag-grid-community";
import {AgGridReact} from "ag-grid-react";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import ContentBody from "../../common/content-body/ContentBody";
import CustomLoader from "../../../../util/component/CustomLoader";
import {getDashboardHistory} from "../service/contractorSearch.actions";
import {useTranslation} from "react-i18next";

const DashboardHistory = (props: any) => {
    const {t} = useTranslation(['network', 'translation']);
    const [ isSearching, setIsSearching ] = useState(false);
    const gridRef = useRef<AgGridReact>(null);
    const [isFetching, setIsFetcing] = useState<boolean>(false);
    const [rowData, setRowData] = useState([]);

    const downloadFunc = (data: string, fileName?: string) => {
        const linkSource = data;
        const downloadLink = document.createElement('a');
        downloadLink.href = linkSource;
        downloadLink.download = fileName ? fileName : 'file';
        downloadLink.click();
    };
    const downloadDocument = (base64: string | ArrayBuffer, fileName?: string) => {
        downloadFunc(base64.toString(), fileName);
    };

    const columnDefs = useMemo<ColDef[]>(() => [
        {field: 'year', rowGroup:true, hide: true},
        {field: 'fileNameVersion'},
        {field: 'fileName'},
        {field: 'uploadDate'},
        {field: 'version'},
        {
            headerName: t("contractorMng.dashboardHistory.grid.actions"),
            cellRenderer: (params: ICellRendererParams) => {
                return (
                    <Grid item xs={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                        <Box sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignSelf: "end"
                        }}>
                            <IconButton
                                color="secondary"
                                onClick={() => handleDownload(params.data)}>
                                <DownloadRounded/>
                            </IconButton>
                        </Box>

                        {/*<Box sx={{*/}
                        {/*    display: "flex",*/}
                        {/*    justifyContent: "flex-end",*/}
                        {/*    alignSelf: "end"*/}
                        {/*}}>*/}
                        {/*    <IconButton*/}
                        {/*        color="secondary"*/}
                        {/*        onClick={() => handleDelete(params.data)}>*/}
                        {/*        <DeleteRounded/>*/}
                        {/*    </IconButton>*/}
                        {/*</Box>*/}
                    </Grid>
                );
            }
        }
    ], []);

    const defaultColDef = useMemo(() => {
        return {
            lockPinned: true,
            resizable: true,
            suppressSizeToFit: true,
        }
    }, []);

    const handleDownload = (params: any) => {
        if(params.file){
            downloadDocument(params.file, params.fileName);
        }
    }

    useEffect(()=> {
        setIsFetcing(true);
        const reqFullParams = {
            functionality: props.functionality,
            id: props.id,
            paramRequest: {}
        };
        getDashboardHistory(reqFullParams)
            .then((response: any) => {
                setRowData(response.history.map((d: any) => ({
                    ...d,
                    uploadDate: d.uploadDate.substring(0,10)
                })));
                setIsSearching(false);
                setIsFetcing(false);
            })
            .catch(() => {
                setIsSearching(false);
                setIsFetcing(false);
            })
            .finally(() => {
                setIsSearching(false);
                setIsFetcing(false);
            })
    }, [])

    return (
        <>
            <ContentBody>
                <AgGridCustomTable
                    gridRef={gridRef}
                    columnDefs={columnDefs}
                    rowData={rowData}
                    pagination={false}
                    gridOptions={
                        {
                            onGridReady: (event) => event.api.sizeColumnsToFit(),
                            defaultColDef: defaultColDef,
                        }
                    }
                />
                <CustomLoader loading={isFetching}/>
            </ContentBody>
        </>
    )
}

export default DashboardHistory;